import {ReceiptPortion} from '../../../services/receipt/receiptModel';
import {lineTotalCents, splitCentsEvenly} from '../../../utils/allocation';

export const quantityUnits = (quantity: number) => Math.round(quantity * 1_000_000);
export const normalizeQuantity = (quantity: number) => quantityUnits(quantity) / 1_000_000;

export function allocatePortions(row: {quantity: number; price: number; allocations?: ReceiptPortion[]}, rowIndex = 0, allowed?: string[]) {
  const perParticipant: Record<string, number> = {};
  let assignedUnits = 0;
  let allocatedCents = 0;
  let valid = Number.isFinite(row.quantity) && row.quantity > 0 && row.quantity <= 1_000_000
    && normalizeQuantity(row.quantity) === row.quantity && Number.isFinite(row.price) && row.price >= 0 && row.price <= 1_000_000;
  const portions = (row.allocations ?? []).map((portion, portionIndex) => {
    const keys = portion.participantKeys;
    const weights = portion.basisPoints;
    const units = quantityUnits(portion.quantity);
    const portionValid = Number.isFinite(portion.quantity) && units > 0 && portion.quantity <= 1_000_000
      && keys.length > 0 && keys.length <= 200 && new Set(keys).size === keys.length
      && keys.every(key => /^(user|guest):[1-9]\d*$/.test(key) && (!allowed || allowed.includes(key)))
      && (!weights || (weights.length === keys.length && weights.every(weight => Number.isInteger(weight) && weight > 0 && weight <= 10000)
        && weights.reduce((sum, weight) => sum + weight, 0) === 10000));
    assignedUnits += units;
    valid = valid && portionValid && assignedUnits <= quantityUnits(row.quantity);
    const cumulative = lineTotalCents({quantity: assignedUnits / 1_000_000, price: row.price});
    const amountCents = cumulative - allocatedCents;
    allocatedCents = cumulative;
    let shares = splitCentsEvenly(amountCents, keys.length, rowIndex + portionIndex);
    if (portionValid && weights) {
      let weightSum = 0;
      let distributed = 0;
      shares = weights.map(weight => {
        weightSum += weight;
        const cumulativeShare = Number((BigInt(amountCents) * BigInt(weightSum) + BigInt(5000)) / BigInt(10000));
        const share = cumulativeShare - distributed;
        distributed = cumulativeShare;
        return share;
      });
    }
    if (portionValid) keys.forEach((key, index) => {
      perParticipant[key] = (perParticipant[key] ?? 0) + shares[index];
    });
    return {amountCents, shares};
  });
  valid = valid && (row.allocations?.length ?? 0) <= 500;
  return {valid, complete: valid && assignedUnits === quantityUnits(row.quantity),
    remaining: normalizeQuantity(row.quantity - assignedUnits / 1_000_000),
    assignedQuantity: assignedUnits / 1_000_000, allocatedCents, perParticipant, portions};
}
